import { CustomTooltip, ICustomTooltipProps } from '@cian/ui-kit';

import * as React from 'react';

import * as styles from './styles.css';

export interface ITooltipProps extends Partial<ICustomTooltipProps> {
  content: React.ReactNode;
}

export const Tooltip: React.FC<ITooltipProps> = props => {
  const { children, content, ...otherProps } = props;
  const ref = React.useRef(null);

  const [isOpen, setOpen] = React.useState(false);
  const onClick = () => setOpen(prevIsOpen => !prevIsOpen);

  const onClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <CustomTooltip
        arrow
        outside
        theme="white"
        placement="top-start"
        open={isOpen}
        onClose={onClose}
        anchorRef={ref}
        content={content}
        {...otherProps}
      />
      <div ref={ref} onClick={onClick} className={styles['root']}>
        {children}
      </div>
    </>
  );
};

Tooltip.displayName = 'Tooltip';
